import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const sliders: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M2.75-1v1H0v-1ZM5.5-2c.133 0 .25.055.344.156.101.094.156.211.156.344v2c0 .133-.055.25-.156.344A.46.46 0 0 1 5.5 1h-2a.5.5 0 0 1-.36-.156A.47.47 0 0 1 3 .5v-2q0-.201.14-.344A.5.5 0 0 1 3.5-2zm1.25-3v1H0v-1zm-5-4v1H0v-1zM12-1v1H6.25v-1Zm-7.5-9c.133 0 .25.055.344.156.101.094.156.211.156.344v2a.5.5 0 0 1-.156.36A.47.47 0 0 1 4.5-7h-2a.52.52 0 0 1-.36-.14A.52.52 0 0 1 2-7.5v-2q0-.201.14-.344A.5.5 0 0 1 2.5-10zm5 4c.133 0 .25.055.344.156.101.094.156.211.156.344v2a.5.5 0 0 1-.156.36A.47.47 0 0 1 9.5-3h-2a.52.52 0 0 1-.36-.14A.52.52 0 0 1 7-3.5v-2q0-.201.14-.344A.5.5 0 0 1 7.5-6zM12-5v1h-1.75v-1zm0-4v1H5.25v-1zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 10)"
    />
  ),
  svgProps: {
    height: "11",
    width: "12",
  }
};
